import typography from 'styles/skipper/typography';
import shadows from './shadows';

export default {
  MuiChip: {
    styleOverrides: {
      root: {
        height: 34,
      },
      avatar: {
        marginLeft: 1,
        marginTop: 2,
        marginBottom: 2,
      },
    },
  },
  MuiAccordion: {
    styleOverrides: {
      root: {
        boxShadow: shadows[2],
      },
    },
  },
  MuiButton: {
    styleOverrides: {
      root: {
        textTransform: 'capitalize',
      },
      contained: {
        boxShadow: shadows[0],
      },
      text: {
        padding: '6px 12px',
      },
    },
  },
  MuiLink: {
    defaultProps: {
      underline: 'hover',
    },
  },
  MuiButtonGroup: {
    styleOverrides: {
      contained: {
        boxShadow: shadows[0],
      },
    },
  },
  MuiCard: {
    styleOverrides: {
      root: {
        boxShadow: shadows[2],
      },
    },
  },
  MuiDialogActions: {
    styleOverrides: {
      root: {
        padding: 24,
      },
    },
  },
  MuiDialogContent: {
    styleOverrides: {
      root: {
        padding: '0 24px',
      },
    },
  },
  MuiDialogContentText: {
    styleOverrides: {
      root: {
        marginBottom: 0,
        ...typography.body2,
      },
    },
  },
  MuiDialogTitle: {
    styleOverrides: {
      root: {
        ...typography.h5,
        padding: 24,
        '& span': {
          display: 'block',
          ...typography.body1,
        },
      },
    },
  },
  MuiFormHelperText: {
    styleOverrides: {
      root: {
        marginLeft: 0,
      },
    },
  },
  MuiMenu: {
    styleOverrides: {
      paper: {
        boxShadow: shadows[3],
      },
    },
  },
  MuiTooltip: {
    styleOverrides: {
      tooltip: {
        ...typography.subtitle1,
      },
    },
  },
  MuiTable: {
    styleOverrides: {
      root: {
        '& caption': {
          ...typography.caption,
        },
      },
    },
  },
  MuiTab: {
    styleOverrides: {
      root: {
        textTransform: 'capitalize',
      },
    },
  },
  MuiToggleButton: {
    styleOverrides: {
      root: {
        textTransform: 'capitalize',
      },
    },
  },
};
